import { useEffect, useState } from "react";

import "../styles/BetterTogetherSection.css";

export default function BetterTogetherSectionComponent() {
  const [viewWidth, setViewWidth] = useState(() => window.innerWidth);
  const betterTogetherReasons = [
    { title: "All in one, working together for you", description: "Manage your online presence effortlessly in one secure place with our comprehensive, all-in-one suite of industry-leading products and services. ​" },
    { title: "Award-winning support when you need it", description: "Access expert support from a top-rated team that businesses worldwide and of all sizes trust. ​" },
    { title: "Security and stability you can trust", description: "Rely on our long-standing commitment to providing robust, secure solutions that ensure the safety and stability of your business." },
    { title: "Innovative solutions that grow with you", description: "Future-proof your business with flexible, forward-thinking solutions that evolve with your business to drive lasting success." },
  ];

  useEffect(() => {
    const handleResize = () => setViewWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="better-together-section">
      <div className="better-together-panel">
        <div className="better-together-header">
          <p className="better-together-eyebrow">Better Together</p>
          <h1 className="better-together-heading">
            {viewWidth > '1025' ?
              'Web.com + Network Solutions. Better together - better for you!'
              :
              'Web.com + Network Solutions. Better Together!'}
          </h1>
        </div>
        <div className="better-together-reasons">
          {betterTogetherReasons.map((reason, index) => (
            <div key={index} className="reason-item">
              <span className="reason-number">0{index + 1}</span>
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
        <div className="better-together-buttons">
          <a href="https://www.networksolutions.com/?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100" className="ns-button">visit network solutions</a>
          <a href="https://www.networksolutions.com/blog/webdotcom-becomes-network-solutions/?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100" className="ns-button">read blog article</a>
        </div>
      </div>
    </section>
  );
}